import { Collapse } from 'bootstrap';

const changeEvent = new Event('rccChange');
class RadioCollapseControl {
    constructor(el) {
        this.el = el;
        this.radios = [];
        let findRadios = this.el.querySelectorAll('input[type="radio"]');
        if(findRadios) {
            findRadios.forEach(r => {
                let findTarget = document.querySelector(r.dataset.rccTarget);
                this.radios.push({
                    el: r,
                    collapseEl: findTarget == null ? null : Collapse.getOrCreateInstance(findTarget, {
                        toggle: false
                    }),
                    childCheckboxes: findTarget == null ? null : findTarget.querySelectorAll('input[type="checkbox"]'),
                    childTextFields: findTarget == null ? null : findTarget.querySelectorAll('input[type="text"]')
                });
                r.onclick = () => {
                    this.update();
                }
            });
        }
        this.update();
    }

    update() {
        for(let x = 0, l = this.radios.length; x < l; x++) {
            let r = this.radios[x];
            if(r.collapseEl != null) {
                if(r.el.checked) {
                    r.collapseEl.show();
                    r.el.setAttribute('aria-expanded', true);
                } else {
                    r.collapseEl.hide();
                    r.el.setAttribute('aria-expanded', false);
                    // clear some child form fields
                    if(r.childCheckboxes) {
                        r.childCheckboxes.forEach(c => {
                            c.checked = false;
                            c.removeAttribute('checked');
                        });
                    }
                    if(r.TextFields) {
                        r.TextFields.forEach(t => {
                            t.value = '';
                        });
                    }
                }
            }
        }
        window.dispatchEvent(changeEvent);
    }
}

export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new RadioCollapseControl(node);
        }
    });
}